<template>
  <div class="searchContainer" :class="{ show: show }">
    <div class="closeBtnBox">
      <span class="closeBtn el-icon-close" @click="close"></span>
    </div>
    <div class="searchInputBox">
      <el-input ref="searchInputRef" placeholder="请输入搜索内容" size="small" v-model="searchText"
        @keyup.native.enter.stop="onSearchNext" @keydown.native.stop @focus="onFocus" @blur="onBlur">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
        <el-button size="small" slot="append" v-if="!isUndef(searchText)" @click="showReplaceInput = true">替换</el-button>
      </el-input>
      <div class="searchInfo" v-if="showSearchInfo">
        {{ currentIndex }} / {{ total }}
      </div>
    </div>
    <el-input v-if="showReplaceInput" ref="replaceInputRef" placeholder="请输入替换内容" size="small"
      v-model="replaceText" style="margin: 12px 0;" @keydown.native.stop @focus="onFocus" @blur="onBlur">
      <i slot="prefix" class="el-input__icon el-icon-edit"></i>
      <el-button size="small" slot="append" @click="hideReplaceInput">
        取消
      </el-button>
    </el-input>
    <div class="btnList" v-if="showReplaceInput">
      <el-button size="small" :disabled="isReadonly" @click="replace">
        替换
      </el-button>
      <el-button size="small" :disabled="isReadonly" @click="replaceAll">
        替换全部
      </el-button>
    </div>
    <div class="searchResultList" :style="{ height: searchResultListHeight + 'px' }" v-if="showSearchResultList">
      <div class="searchResultItem" v-for="(item, index) in searchResultList" :key="item.id" :title="item.name"
        v-html="item.text" @click.stop="onSearchResultItemClick(index)"></div>
      <div class="empty" v-if="searchResultList.length <= 0">
        <span class="iconfont iconwushuju"></span>
        <span class="text">暂无结果</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getTextFromHtml, isUndef } from 'simple-mind-map/src/utils/index';
import { mapState } from 'vuex';
// 搜索替换
export default {
  name: 'Search',
  props: {
    mindMap: {
      type: Object
    }
  },
  data() {
    return {
      show: false,
      searchText: '',
      replaceText: '',
      showReplaceInput: false,
      currentIndex: 0,
      total: 0,
      showSearchInfo: false,
      searchResultListHeight: 0,
      searchResultList: [],
      showSearchResultList: false
    }
  },
  computed: {
    ...mapState({
      isReadonly: state => state.isReadonly,
    })
  },
  watch: {
    searchText() {
      if (isUndef(this.searchText)) {
        this.currentIndex = 0
        this.total = 0
        this.showSearchInfo = false
      }
    },
    
    // 监听mindMap的变化，当mindMap初始化完成后重新绑定事件
    mindMap: {
      handler(newVal, oldVal) {
        console.log('SearchBar mindMap changed:', { newVal, oldVal })
        if (newVal && newVal !== oldVal) {
          this.bindMindMapEvents()
        }
      },
      immediate: true
    }
  },
  created() {
    console.log('SearchBar created, mindMap:', this.mindMap)
    console.log('SearchBar mindMap.search:', this.mindMap?.search)
    this.$bus.$on('show_search', this.showSearch)
    window.addEventListener('resize', this.setSearchResultListHeight)
  },
  mounted() {
    this.setSearchResultListHeight()
  },
  beforeDestroy() {
    this.$bus.$off('show_search', this.showSearch)
    this.unbindMindMapEvents()
    window.removeEventListener('resize', this.setSearchResultListHeight)
  },
  methods: {
    isUndef,

    // 绑定MindMap事件
    bindMindMapEvents() {
      console.log('绑定MindMap事件, mindMap:', this.mindMap)
      if (!this.mindMap || !this.mindMap.on) {
        console.warn('MindMap未初始化，无法绑定事件')
        return
      }
      
      try {
        // 先解绑旧事件（如果存在）
        this.unbindMindMapEvents()
        
        // 绑定新事件
        this.mindMap.on('search_info_change', this.handleSearchInfoChange)
        this.mindMap.on('node_click', this.blur)
        this.mindMap.on('draw_click', this.blur)
        this.mindMap.on('expand_btn_click', this.blur)
        this.mindMap.on('search_match_node_list_change', this.onSearchMatchNodeListChange)
        
        // 绑定快捷键
        if (this.mindMap.keyCommand) {
          this.mindMap.keyCommand.addShortcut('Control+f', this.showSearch)
        }
        
        console.log('MindMap事件绑定成功')
      } catch (error) {
        console.error('绑定MindMap事件失败:', error)
      }
    },

    // 解绑MindMap事件
    unbindMindMapEvents() {
      if (!this.mindMap || !this.mindMap.off) {
        return
      }
      
      try {
        this.mindMap.off('search_info_change', this.handleSearchInfoChange)
        this.mindMap.off('node_click', this.blur)
        this.mindMap.off('draw_click', this.blur)
        this.mindMap.off('expand_btn_click', this.blur)
        this.mindMap.off('search_match_node_list_change', this.onSearchMatchNodeListChange)
        
        if (this.mindMap.keyCommand) {
          this.mindMap.keyCommand.removeShortcut('Control+f', this.showSearch)
        }
      } catch (error) {
        console.error('解绑MindMap事件失败:', error)
      }
    },

    handleSearchInfoChange(data) {
      this.currentIndex = data.currentIndex + 1
      this.total = data.total
      this.showSearchInfo = true
    },

    showSearch() {
      console.log('showSearch被调用')
      console.log('当前mindMap状态:', this.mindMap)
      console.log('当前mindMap.search状态:', this.mindMap?.search)
      
      this.$bus.$emit('closeSideBar')
      this.show = true
      
      console.log('搜索面板显示状态设置为:', this.show)
      
      // 延迟聚焦，确保DOM已更新
      this.$nextTick(() => {
        if (this.$refs.searchInputRef) {
          this.$refs.searchInputRef.focus()
          console.log('搜索输入框已聚焦')
        } else {
          console.warn('搜索输入框引用不存在')
        }
      })
    },

    hideReplaceInput() {
      this.showReplaceInput = false
      this.replaceText = ''
    },

    // 输入框聚焦时，禁止思维导图节点响应按键事件自动进入文本编辑
    onFocus() {
      if (this.mindMap && this.mindMap.updateConfig) {
        this.mindMap.updateConfig({
          enableAutoEnterTextEditWhenKeydown: false
        })
      }
    },

    // 输入框失焦时恢复
    onBlur() {
      if (this.mindMap && this.mindMap.updateConfig) {
        this.mindMap.updateConfig({
          enableAutoEnterTextEditWhenKeydown: true
        })
      }
    },

    // 画布，节点点击时让输入框失焦
    blur() {
      if (this.$refs.searchInputRef) {
        this.$refs.searchInputRef.blur()
      }
      if (this.$refs.replaceInputRef) {
        this.$refs.replaceInputRef.blur()
      }
    },

    onSearchNext() {
      if (!this.mindMap || !this.mindMap.search) {
        console.error('MindMap或Search插件未初始化')
        this.$message.error('搜索功能未初始化，请刷新页面重试')
        return
      }
      this.showSearchResultList = true
      try {
        this.mindMap.search.search(this.searchText)
      } catch (error) {
        console.error('搜索失败:', error)
        this.$message.error('搜索失败: ' + error.message)
      }
    },

    replace() {
      if (!this.mindMap || !this.mindMap.search) {
        console.error('MindMap或Search插件未初始化')
        this.$message.error('替换功能未初始化，请刷新页面重试')
        return
      }
      try {
        this.mindMap.search.replace(this.replaceText, true)
        this.$message.success('替换成功')
      } catch (error) {
        console.error('替换失败:', error)
        this.$message.error('替换失败: ' + error.message)
      }
    },

    replaceAll() {
      if (!this.mindMap || !this.mindMap.search) {
        console.error('MindMap或Search插件未初始化')
        this.$message.error('替换功能未初始化，请刷新页面重试')
        return
      }
      try {
        this.mindMap.search.replaceAll(this.replaceText)
        this.$message.success('全部替换成功')
      } catch (error) {
        console.error('全部替换失败:', error)
        this.$message.error('全部替换失败: ' + error.message)
      }
    },

    close() {
      this.show = false
      this.showSearchResultList = false
      this.showSearchInfo = false
      this.total = 0
      this.currentIndex = 0
      this.searchText = ''
      this.hideReplaceInput()
      if (this.mindMap && this.mindMap.search) {
        try {
          this.mindMap.search.endSearch()
        } catch (error) {
          console.error('结束搜索失败:', error)
        }
      }
    },

    onSearchMatchNodeListChange(list) {
      this.searchResultList = list.map(item => {
        const data = item.data || item.nodeData.data
        let name = data.text
        const id = data.uid
        if (data.richText) {
          name = getTextFromHtml(name)
        }
        // 添加 i 标志使正则匹配大小写不敏感
        const reg = new RegExp(`${this.searchText.trim()}`, 'gi')
        const text = name.replace(reg, a => {
          return `<span class="match">${a}</span>`
        })
        return {
          data: item,
          id,
          text,
          name
        }
      })
    },

    setSearchResultListHeight() {
      this.searchResultListHeight = window.innerHeight - 267 - 24
    },

    onSearchResultItemClick(index) {
      if (!this.mindMap || !this.mindMap.search) {
        console.error('MindMap或Search插件未初始化')
        this.$message.error('跳转功能未初始化，请刷新页面重试')
        return
      }
      try {
        this.mindMap.search.jump(index)
      } catch (error) {
        console.error('跳转失败:', error)
        this.$message.error('跳转失败: ' + error.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.searchContainer {
  background-color: #fff;
  padding: 16px;
  width: 296px;
  border-radius: 12px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 80px;
  right: -346px;
  transition: all 0.3s;

  &.show {
    right: 20px;
  }

  .btnList {
    display: flex;
    justify-content: flex-end;
  }

  .closeBtnBox {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 20px;
    height: 20px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);

    .closeBtn {
      font-size: 16px;
    }
  }

  .searchInputBox {
    position: relative;

    .searchInfo {
      position: absolute;
      right: 70px;
      top: 50%;
      transform: translateY(-50%);
      color: #909090;
      font-size: 14px;
    }
  }

  .searchResultList {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-top: 5px;
    overflow-y: auto;
    padding: 12px 0;

    .searchResultItem {
      height: 30px;
      line-height: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 12px;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      padding-left: 22px;

      &::before {
        content: '';
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 5px;
        height: 5px;
        background-color: #606266;
        border-radius: 50%;
      }

      &:hover {
        background-color: #f2f4f7;
      }

    }

    .empty {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .iconfont {
        font-size: 50px;
        margin-bottom: 20px;
      }

      .text {
        font-size: 14px;
        color: rgba(26, 26, 26, 0.8);
      }
    }
  }
}
</style>
